'use client'

import { useState, useEffect } from 'react'

export default function Toast({ text }: { text: string }) {
	const params =
		typeof document !== 'undefined'
			? new URL(document.location.toString()).searchParams
			: null
	const [isTimeout, setIsTimeout] = useState(false)

	useEffect(() => {
		if (!params?.get('aliId')) return

		const timer = setTimeout(() => {
			params?.delete('aliId')
			setIsTimeout(true)
		}, 4000)

		// Nettoyage du timeout si le composant est démonté
		return () => clearTimeout(timer)
	}, [params])

	return !!params?.get('aliId') && !isTimeout ? (
		<div className="absolute top-0 right-12 max-w-72 p-8 bg-white rounded-2xl border border-gray-100 z-50">
			{text}
			<div className="h-1 mt-4 bg-red-500 animate-growidth" />
		</div>
	) : (
		''
	)
}
